exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "/* purgecss start ignore */\ndiv.money_format[data-v-5180a156] {\n  display: inline-block;\n  font-weight: 700;\n}\n\n/* purgecss end ignore */\n", ""]);

// exports
